import { FC } from 'react';
import styled from 'styled-components';

export const Link = styled.a<FC<HTMLAnchorElement>>`
  text-transform: none;
  color: #157efb; /* TODO: theme */
  font-weight: normal;

  &:active,
  &:hover,
  &:focus {
    color: #0d65cd; /* TODO: theme */
  }

  /* Theming Overrides */
  ${({ theme }) => theme?.overrides?.Link}
`;

export const ExternalLink = styled(Link).attrs(() => ({
  rel: 'noreferrer noopener nofollow',
}))`
  &:after {
    content: ' (external)';
  }
  /* Theming Overrides */
  ${({ theme }) => theme?.overrides?.ExternalLink}
`;
